import ButtonOutlined from '@components/button-outlined';
import { useContext } from 'react';
import { PlayerContext } from './player';
import styles from './player.module.scss';

const PlayerActions = (): JSX.Element => {
  const { currentPlayerId, player } = useContext(PlayerContext);

  if (!player) return <></>;

  const { user, status } = player!;

  /* Components */

  const GameControls: JSX.Element = (
    <>
      <ButtonOutlined onClick={() => {}} color="green">
        Hit
      </ButtonOutlined>
      <ButtonOutlined onClick={() => {}} color="red">
        Stand
      </ButtonOutlined>
    </>
  );

  const RoomControls: JSX.Element = (
    <>
      <ButtonOutlined onClick={() => {}} color="gray">
        Leave
      </ButtonOutlined>
      <ButtonOutlined onClick={() => {}} color="green">
        Ready
      </ButtonOutlined>
    </>
  );

  return (
    <section className={styles.controls}>
      {currentPlayerId === user.id &&
        true &&
        status !== 'finished' &&
        RoomControls}

      {currentPlayerId === user.id &&
        false &&
        status !== 'finished' &&
        GameControls}
    </section>
  );
};

export default PlayerActions;
